import { baseApi } from "../baseApi";

export const LocationApi = baseApi.injectEndpoints({

  endpoints: (builder) => ({

    // CREATE
    createLocation: builder.mutation({
      query: (formData) => ({
        url: "/location-create",
        method: "POST",
        body: formData,
      }),

      invalidatesTags: ["Location"],
    }),

    // GET ALL
    getLocation: builder.query({
      query: ({ page = 1,limit = 10,search = "",status = "",}={}) =>
         `/location-list?page=${page}&limit=${limit}&search=${search}&status=${status}`,

      providesTags: ["Location"],
    }),
    // UPDATE
  updateLocation: builder.mutation({
  query: (data) => ({
    url: `/location-edit`,
    method: "POST",
    body: data,
  }),

  invalidatesTags: ["Location"],
}),
  changeStatusLocation: builder.mutation({
  query: (id) => ({
    url: `/location-status/${id}`,
    method: "GET",
  }),

  invalidatesTags: ["Location"],
}),

deleteLocation: builder.mutation({
  query: (data) => ({
    url: `/location-delete`,
    method: "DELETE",
    body:data
  }),

  invalidatesTags: ["Location"],
}),
viewLocation: builder.mutation({
  query: (id) => ({
    url: `/location-view/${id}`,
    method: "GET",
  }),

  invalidatesTags: ["Location"],
}),

  }),

});

export const {
  useCreateLocationMutation,
  useGetLocationQuery,
  useUpdateLocationMutation,
  useDeleteLocationMutation,
  useChangeStatusLocationMutation

} = LocationApi;